import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import MorphCommand from '../../commands/MorphCommand';
import WalkCommand from '../../commands/WalkCommand';

export default class TutorialLevel10 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		if (this.stage === 0) {
			common.focusOverlay.setFocus(25, 70, 280, 80);

			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 - this._commands.ui.x + 200, 130);
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE10.SELECT_FOURARMS');
			this.signals.update.dispatch();

			this._commands.commands[2].canChangeVariable = false;
			this._commands.ui.add.interactive = false;
			// this._commands.toolboxItems[0].ui.interactive = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			common.focusOverlay.setFocus(25, 70, 575, 80);

			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 - this._commands.ui.x + 550, 130);
			this._finger.scale.set(1);
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE10.SELECT_FOURARMS');
			this.signals.update.dispatch();

			this._commands.ui.interactiveChildren = true;
			if (this._commands.selector) {
				this._commands.selector.children[1].interactive = false;
				this._commands.selector.children[2].interactive = false;
			}

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			common.focusOverlay.setFocus(25, 140, 280, 80);

			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 200, 200);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE10.WALK_VARIABLES');
			this.signals.update.dispatch();

			this._commands.commands[1].canChangeVariable = false;
			this._commands.commands[2].canChangeVariable = true;

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 3) {
			common.focusOverlay.setFocus(25, 140, 425, 80);

			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 420, 200);
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE10.WALK_VARIABLES');
			this.signals.update.dispatch();

			if (this._commands.selector) {
				this._commands.selector.children[1].interactive = false;
			}

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => lastTween.start());
		} else if (this.stage === 4) {
			common.focusOverlay.setFocus(20, 60, 380, 215);

			this._finger.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 280, 140);
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE10.FINISH');
			this.signals.update.dispatch();

			this._commands.ui.add.interactive = true;
			this._commands.commands[2].canChangeVariable = false;

			this._finger.visible = false;
			common.focusOverlay.visible = false;
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 2; i++) {
			let command = null;

			if (i === 0) {
				command = new MorphCommand();
			} else {
				command = new WalkCommand();
			}

			command.template = false;
			command.grabbable = false;
			command.locked = true;
			command.placed = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();

			command.interactive = true;
			command.signals.pickup.detachAll();
			command.variable = command.defaultVariable;
			command.signals.touch.add(this._commands.onCommandTouch, this._commands);
			command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
		}
	}
}
